import { bool, func, number, object, shape } from 'prop-types'
import { Button } from '@opallabs/kuiper'
import { buildMenu } from './helpers'

import './styles.scss'

const popoverOptions = {
  hasCaret: true,
}

const TaskContextualMenu = ({
  enabledIntegrations,
  integrationTask,
  onContextMenuAction,
  phase,
  task,
}) => (
  <Button
    closeOnSelect={true}
    hideLabelText={true}
    icon="gem-settings"
    iconOptions={{
      height: 14,
      width: 14,
      ariaLabel: 'Manage task',
      ariaMode: 'presentational',
      system: 'gem',
    }}
    label="Manage task"
    noArrow={true}
    onSelect={onContextMenuAction}
    options={buildMenu(task, phase, enabledIntegrations, integrationTask)}
    popoverOptions={popoverOptions}
    type="invisible"
  />
)

TaskContextualMenu.propTypes = {
  enabledIntegrations: object,
  integrationTask: object,
  onContextMenuAction: func.isRequired,
  phase: shape({
    isLocked: bool,
    itemCount: number,
  }).isRequired,
  task: shape({
    isComplete: bool,
  }).isRequired,
}

export default TaskContextualMenu
